// Basic un-sortable list for displaying execution tasks.
import { Box } from '@mui/material';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { TaskUIProvider, useTaskUI } from '@/features/tasks/context/TaskUIContext';
import TaskItemSwipeable from '@/features/tasks/components/items/TaskItemSwipeable';
import TaskItemToday from '@/features/tasks/components/items/TaskItemToday';
import TaskItemMobileSortable from '@/features/tasks/components/items/TaskItemMobileSortable';
import { generateBreadcrumbPath } from '@/features/tasks/utils/structure/taskHierarchy';

const TaskListSimple = ({
  tasks,
  leftSwipeAction,
  topActionableTaskId,
  tasksMap,
  showPlayButtonAlways = false,
  dragEnabled = false,
  listId = null,
  taskType = null,
  menuSurface = null,
}) => {
  const parentUi = useTaskUI();
  const renderTask = (task) => {
    const swipeable = (
      <TaskItemSwipeable task={task} leftSwipeAction={leftSwipeAction}>
        <TaskItemToday
          task={task}
          indentationType="none"
          view="today"
          showPlayButton={
            showPlayButtonAlways || task.id === topActionableTaskId
          }
          breadcrumb={generateBreadcrumbPath(task, tasksMap)}
        />
      </TaskItemSwipeable>
    );

    if (dragEnabled && taskType) {
      return (
        <TaskItemMobileSortable key={task.id} task={task} type={taskType}>
          {swipeable}
        </TaskItemMobileSortable>
      );
    }

    return <Box key={task.id}>{swipeable}</Box>;
  };

  const content = (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 4 }}>
      {tasks.map(renderTask)}
    </Box>
  );

  const wrappedContent =
    dragEnabled && listId && taskType ? (
      <SortableContext
        items={tasks.map((task) => task.id)}
        strategy={verticalListSortingStrategy}
        id={listId}
      >
        {content}
      </SortableContext>
    ) : (
      content
    );

  if (!menuSurface) return wrappedContent;

  return (
    <TaskUIProvider value={{ ...parentUi, menuSurface }}>
      {wrappedContent}
    </TaskUIProvider>
  );
};

export default TaskListSimple;
